import { useTranslation } from "react-i18next";
import { Q3DDataTable, Q3DDataTableHeaderType } from "../../Parts/Q3DDataTable";
import HelmContext from "../Contexts/HelmContext";
import { useContext, useEffect, useState } from "react";
import {
  EDialogType,
  EDisplayType,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { ECoordinateTransformMode } from "../../config/componentsConfig";
import _ from "lodash";
import PointUtil from "../../Utility/PointUtil";

type Props = {};

export const HelmInputContent = (props: Props) => {
  const { t } = useTranslation();
  const { projectDetail, updateCurrentDialog, displayType } =
    useContext(ProjectDetailContext);
  const {
    coordinatePoints,
    setCoordinatePoints,
    fetchCoordinatePoints,
    handleDelete,
    handleAdd,
    handleSave,
  } = useContext(HelmContext);

  useEffect(() => {
    fetchCoordinatePoints(projectDetail.id);
  }, []);

  const headers = [
    {
      key: "tool",
      name: "",
      type: "icon",
    },
    {
      key: "pointName",
      name: t("POINT_NAME"),
      type: "textInput",
    },
    {
      key: "timeStamp",
      name: t("DATE"),
      type: "date",
    },
    {
      key: "x",
      name: t("X_COORDINATE"),
      type: "numberInput",
      sx: {
        textAlign: "right",
        paddingRight: displayType === EDisplayType.iOS ? "0" : "19px",
      },
    },
    {
      key: "y",
      name: t("Y_COORDINATE"),
      type: "numberInput",
      sx: {
        textAlign: "right",
        paddingRight: displayType === EDisplayType.iOS ? "0" : "19px",
      },
    },
    {
      key: "z",
      name: t("Z_COORDINATE"),
      type: "numberInput",
      sx: {
        textAlign: "right",
        paddingRight: displayType === EDisplayType.iOS ? "0" : "19px",
      },
    },
  ] as Q3DDataTableHeaderType[];

  const updateRowsData = (id: string, key: string, value: string) => {
    setCoordinatePoints(
      coordinatePoints.map((data) => {
        if (data.id === id) {
          (data as any)[key] = value;
        }
        return data;
      })
    );
  };

  const saveFunction = (id: string, key: string, value: string) => {
    try {
      if (value !== "" && id !== "" && key !== "") {
        PointUtil.updateRecord(id, key, value, projectDetail.id);
      }
    } catch (err) {
      console.error("Error Msg:", err);
    }
  };
  // 保存制御処理
  const debouncedSave = _.debounce(saveFunction, 1000);

  return (
    <Q3DDataTable
      headers={headers}
      rows={coordinatePoints}
      onClickHeaderButton={() => {
        updateCurrentDialog(EDialogType.DELETE_ALL_POINTS);
      }}
      onClickRowButton={(row: string, isSave: boolean) => {
        if (isSave) {
          handleSave(ECoordinateTransformMode.INPUT, row);
        } else {
          handleDelete(ECoordinateTransformMode.INPUT, row);
        }
      }}
      onClickBottomButton={() => {
        handleAdd(ECoordinateTransformMode.INPUT);
      }}
      onChange={(id: string, key: string, value: any) => {
        updateRowsData(id, key, value);
        debouncedSave(id, key, value);
      }}
    />
  );
};
